import { render, staticRenderFns } from "./RolesDetailsIcon.vue?vue&type=template&id=9ed71230&"
import script from "./RolesDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./RolesDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports